export * from './common'
export MainContent from './MainContent'
export InformativeContent from './InformativeContent'
